"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Headline_1 = require("../../atoms/Headline");

var IconLink_1 = require("../IconLink");

var defaultProps = {
  showInMobile: true
};
/**
 * @visibleName IconNavigation.Column
 */

var Column = function Column(_a) {
  var children = _a.children,
      title = _a.title;
  return React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "footer-iconnavigation-column"
  }, React.createElement(Headline_1.H4, null, title), React.createElement(IconLink_1.IconLinkGroup, {
    direction: IconLink_1.IconLinkGroup.Directions.VERTICAL,
    className: CSSPrefix_1.lsgPre + "footer-iconnavigation-column-items"
  }, children));
};

exports.Column = Column;
Column.defaultProps = defaultProps;
Column.displayName = "IconNavigation.Column";